import script from "./DoneNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./DoneNotification.vue?vue&type=script&setup=true&lang=js"

import "./DoneNotification.vue?vue&type=style&index=0&id=deecda52&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deecda52"]])

export default __exports__